const DEFAULT_PDF_OVERLAY_ERROR_MESSAGE =
  'ไม่สามารถสร้าง PDF Overlay ได้ กรุณาตรวจสอบข้อมูลแล้วลองใหม่อีกครั้ง'

const getResponseErrorData = async (error) => {
  const responseData = error?.response?.data

  if (responseData && typeof responseData.text === 'function') {
    try {
      const responseText = await responseData.text()
      return JSON.parse(responseText)
    } catch (responseError) {
      return null
    }
  }

  return responseData
}

export const getPdfOverlayPreviewErrorMessage = async (error) => {
  const responseData = await getResponseErrorData(error)
  const errorMessage = `${
    responseData?.message || error?.message || ''
  }`.trim()

  if (errorMessage.includes('template revision')) {
    return 'ไฟล์ PDF ถูกเปลี่ยน แต่พิกัดยังเป็นของไฟล์เดิม กรุณากลับไปที่ Designer รอให้ระบบสร้างพิกัดใหม่ แล้วกดบันทึกอีกครั้ง'
  }

  return errorMessage || DEFAULT_PDF_OVERLAY_ERROR_MESSAGE
}
